export default __webpack_public_path__ + "static/media/members_icon_24m.ab369436.png";